import { authFileHeader } from "."

// return authorization header with password token
export function authHeader() {
    let headers = authFileHeader()
    headers["Content-Type"] = "application/json"

    return headers
}
